export const EstadosBonificados = {
    1: 'PendienteActivacion',
    2: 'Activo', //estado desde suscripciones
    3: 'Suspendido',
    4: 'Baja',
    5: 'PendienteActivacionSuspendido',
    6: 'Activa' //estado que asigno desde adq
}

